import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { SchoolCalendar } from './school-calendar.model';
import { SchoolCalendarPopupService } from './school-calendar-popup.service';
import { SchoolCalendarService } from './school-calendar.service';

@Component({
    selector: 'jhi-school-calendar-delete-dialog',
    templateUrl: './school-calendar-delete-dialog.component.html'
})
export class SchoolCalendarDeleteDialogComponent {

    schoolCalendar: SchoolCalendar;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private schoolCalendarService: SchoolCalendarService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['schoolCalendar']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.schoolCalendarService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'schoolCalendarListModification',
                content: 'Deleted an schoolCalendar'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-school-calendar-delete-popup',
    template: ''
})
export class SchoolCalendarDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private schoolCalendarPopupService: SchoolCalendarPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.schoolCalendarPopupService
                .open(SchoolCalendarDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar-delete-dialog.component.ts